import { Weld } from '@bechtel/types';
import { PersonaType } from '@bechtel/types';

export type WeldItemProps = {
  weld: Weld;
  showSelectOption: boolean;
  onSelectWeldItem: (id: string) => void;
  isChecked?: boolean;
  personaType: PersonaType;
  allowItemSelection: boolean;
  createRodRequest: (weld: Weld) => void;
};
